/** Cart and checkout select saved addresses; My Account owns address editing. */
const addressFields = ['country', 'state', 'first_name', 'last_name', 'company', 'address_1', 'address_2', 'city', 'postcode', 'phone', 'email'];

function initOrderAddresses() {
    const $ = window.jQuery;
    const config = window.aconvertOrderAddresses;
    const progressKey = config ? `aconvert-checkout-progress-${config.user}` : '';
    const inputFor = (section, field) => document.getElementById(`${section.dataset.addressType}_${field}`);

    const refreshSummary = (section) => {
        if (!section.querySelector('.ac-address-select')) return;
        const value = (field) => inputFor(section, field)?.value.trim() || '';
        const state = inputFor(section, 'state');
        const country = inputFor(section, 'country');
        const lines = [
            [value('first_name'), value('last_name')].filter(Boolean).join(' '),
            value('company'), value('address_1'), value('address_2'),
            [value('city'), value('state') ? (state?.selectedOptions?.[0]?.textContent || value('state')) : '', value('postcode')].filter(Boolean).join(', '),
            value('country') ? (country?.selectedOptions?.[0]?.textContent || value('country')) : '',
        ].filter(Boolean);
        const summary = section.querySelector('.ac-address-summary-text');
        summary.replaceChildren();
        lines.forEach((line, index) => {
            if (index) summary.append(document.createElement('br'));
            summary.append(document.createTextNode(line));
        });
        const email = section.querySelector('.ac-billing-email-value');
        if (email) email.textContent = value('email') || email.dataset.emptyLabel;
        section.querySelector('.ac-address-contact').textContent = value('phone');
    };

    document.addEventListener('click', async (event) => {
        const manage = event.target.closest('.ac-address-manage');
        if (manage && config) {
            // Keep notes and delivery/payment choices while visiting the address book.
            try {
                sessionStorage.setItem(progressKey, JSON.stringify({
                    time: Date.now(),
                    notes: document.getElementById('order_comments')?.value || '',
                    payment: document.querySelector('[name="payment_method"]:checked')?.value || '',
                    shipping: Array.from(document.querySelector('input.shipping_method:checked, input.shipping_method[type="hidden"]')).map((input) => input.value),
                }));
            } catch { /* Storage restrictions must not block address management. */ }
            return;
        }
        const button = event.target.closest('button');
        const chooser = button?.closest('.ac-address-chooser');
        if (!chooser) return;
        if (button.classList.contains('ac-address-cancel')) {
            chooser.open = false;
            chooser.querySelector('summary').focus();
            return;
        }
        const section = chooser.closest('.ac-order-address');
        if (!button.classList.contains('ac-address-use') || !section || !$ || !config) return;
        event.preventDefault();
        const select = chooser.querySelector('select');
        const key = select.value;
        if (key === '') {
            select.focus();
            return;
        }
        const status = section.querySelector('.ac-address-status');
        button.disabled = true;
        section.setAttribute('aria-busy', 'true');
        status.textContent = '';
        try {
            const response = await fetch(config.url, {
                method: 'POST', credentials: 'same-origin',
                body: new URLSearchParams({ security: config.nonce, address_type: section.dataset.addressType, address_key: key }),
            });
            const result = await response.json();
            if (!response.ok || !result.success) throw new Error(result.data?.message || config.error);
            addressFields.forEach((field) => {
                const input = inputFor(section, field);
                if (input) $(input).val(result.data.address[field] || '').trigger('change');
            });
            refreshSummary(section);
            chooser.open = false;
            status.textContent = config.updated;
            $(document.body).trigger('update_checkout');
            chooser.querySelector('summary').focus();
        } catch (error) {
            status.textContent = error.message || config.error;
        } finally {
            button.disabled = false;
            section.removeAttribute('aria-busy');
        }
    });

    if (!$ || !config) return;
    $(document.body).on('updated_checkout', () => {
        document.querySelectorAll('.ac-order-address').forEach(refreshSummary);
    });
    try {
        const progress = JSON.parse(sessionStorage.getItem(progressKey) || 'null');
        sessionStorage.removeItem(progressKey);
        if (!progress || Date.now() - progress.time > 30 * 60 * 1000) return;
        const notes = document.getElementById('order_comments');
        if (notes) notes.value = progress.notes;
        $(document.body).one('updated_checkout', () => {
            document.querySelectorAll('[name="payment_method"], input.shipping_method').forEach((input) => {
                const selected = input.name === 'payment_method' ? input.value === progress.payment : progress.shipping.includes(input.value);
                if (selected && !input.checked && input.type === 'radio') {
                    $(input).prop('checked', true).trigger('change');
                }
            });
        });
    } catch { /* Checkout remains usable if storage is unavailable. */ }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrderAddresses);
} else {
    initOrderAddresses();
}
